import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ModalBaseComponent } from '../../../shared/components/modal-base/modal-base.component';
import { SharedModule } from '../../../shared/shared.module';
import { FormValidationService } from '../../../core/services/form-validation.service';
import {
  decimalNumberValidator,
  integerValidator,
} from '../../../core/services/validation.service';
import { InputOption } from '../../../core/models/common/input-option';
import {
  QrInvoiceReminder,
  QrInvoiceReminderDelayType,
} from '../../../core/models/entities/vendor';

export type QrInvoiceReminderFormGroup = FormGroup<{
  days: FormControl<number>;
  fee: FormControl<number>;
  delay_type: FormControl<QrInvoiceReminderDelayType>;
}>;

export function buildQrInvoiceReminderFormGroup(
  reminder?: QrInvoiceReminder,
): QrInvoiceReminderFormGroup {
  return new FormGroup({
    days: new FormControl<number>(reminder?.days ?? null, [
      Validators.required,
      integerValidator,
    ]),
    fee: new FormControl<number>(reminder?.fee ?? 0, [
      Validators.required,
      decimalNumberValidator,
    ]),
    delay_type: new FormControl<QrInvoiceReminderDelayType>(
      reminder?.delay_type ?? QrInvoiceReminderDelayType.DaysAfterDueDate,
    ),
  });
}

@Component({
  selector: 'app-qr-invoice-reminder-modal',
  template: `
    <app-modal [modalInstance]="modalInstance">
      <form [formGroup]="form" novalidate>
        <app-text-input
          [label]="'settings.online-payment.qr-invoice.reminder-delay-label' | transloco"
          name="days"
          [control]="form.controls.days"
          [appendOptions]="delayTypeOptions"
          [appendOptionValue]="form.value.delay_type"
          (appendOptionValueChange)="form.controls.delay_type.patchValue($any($event))"
        ></app-text-input>
        <app-text-input
          [label]="'settings.online-payment.qr-invoice.reminder-fee-label' | transloco"
          prepend="CHF"
          name="fee"
          [control]="form.controls.fee"
          [marginBottom]="false"
        ></app-text-input>
      </form>
    </app-modal>
  `,
  imports: [SharedModule],
})
export class QrInvoiceReminderModalComponent extends ModalBaseComponent {
  private formValidationService = inject(FormValidationService);

  form: QrInvoiceReminderFormGroup = buildQrInvoiceReminderFormGroup();
  delayTypeOptions: InputOption[] = [];

  setData(data: { reminder?: QrInvoiceReminder; delayTypeOptions: InputOption[] }) {
    this.form = buildQrInvoiceReminderFormGroup(data.reminder);
    this.delayTypeOptions = data.delayTypeOptions;
  }

  override canConfirm(): boolean {
    return this.formValidationService.validate(this.form);
  }
}
